import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import NotFound from '../views/NotFound.vue';
import Register from '../views/Register.vue';
import PassConfirmation from '../components/Global/PasswordConfirmNew.vue'
import DashboardCalendar from '../views/DashCalendar/DashboardCalendar.vue'
import DashUser from '../views/DashCalendar/DashUser.vue'
import HomePag from '../components/Global/HomePag.vue'
import IAModel from '@/views/IAModels/IAModel.vue';
import GeneracionProyecto from '@/views/Proyects/GeneracionProyecto.vue';
import NuevoProyecto from '@/views/Proyects/NuevoProyecto.vue';
import ChatGPT from '@/views/ChatGPT/ChatGPT.vue';
import EquiposProyecto from '@/views/Equipos/EquiposProyecto.vue';
import ChatVIew from '@/views/ChatGPT/ChatVIew.vue';
import RegistroUsuario from '@/views/Registro/RegistroUsuario.vue';
import AdminRol from '@/views/AdminUsuarios/AdminRol.vue';
import ProfileView from '@/views/ProfileView.vue';
import MisUsos from '@/views/IAModels/MisUsos.vue';
import AdminLimites from "@/views/AdminUsuarios/AdminLimites.vue";
import UnidadesNegocio from "@/views/UnidadesNegocio/UnidadesNegocio.vue";
import UserUnidadNegocio from '@/views/UnidadesNegocio/UserUnidadNegocio.vue';
import LimiteUnidades from "@/views/UnidadesNegocio/LimiteUnidades.vue";
import LimiteUsuariosUnidad from "@/views/UnidadesNegocio/LimiteUsuariosUnidad.vue";
import UsageUnidadProyectTeam from '@/views/AdminUsuarios/UsosUnidad/UsageUnidadProyectTeam.vue';
import { useAuthStore } from "@/stores/auth";



const routes = [

    {
        path: '/index',
        name: 'LoginPage',
        component: Login
        // children:[{
        //     path: 'dashboard',
        //     name:'dasboardPage',
        //     component:Dashboard
        // },
        // ]
    },
   

    {
        path: '/dashboard',
        name: 'dasboardPage',
        component: Dashboard,
        children: [

            {
                path: 'dashCalendar',
                name: 'DashboardCalendar',
                //component: () => import('@/views/DashCalendar.vue')
                component: DashboardCalendar,
            }, {
                path: 'dashUser/:id/:name/:email',
                name: 'userDash',
                component: DashUser,
            },
            {
                path: 'IAModels',
                name: 'IAModel',
                component: IAModel,
            },
            {
                path: 'ChatGPT',
                name: 'ChatModel',
                component:ChatGPT,
            },
            {
                path: "/mi-consumo",
                name: "MisUsos",
                component:MisUsos,
                
            },
            {
                path: "/dashboard-consumo",
                name: "UsageUnidadProyectTeam",
                component:UsageUnidadProyectTeam,
                
            },
            {
    path: "/admin/limites",
    name: "AdminLimites",
    component: AdminLimites,
    meta: { adminOnly: true },
  },
            {
    path: "unidades-negocio",
    name: "UnidadesNegocio",
    component: UnidadesNegocio,
    meta: { adminOnly: true },
  },
        {
    path: "user-unidades-negocio",
    name: "UserUnidadNegocio",
    component: UserUnidadNegocio,
    meta: { adminOnly: true },
  },
        {
    path: "limite-unidades",
    name: "LimiteUnidades",
    component: LimiteUnidades,
    meta: { adminOnly: true },
  },
        {
    path: "mi-unidad-limites",
    name: "LimiteUsuariosUnidad",
    component: LimiteUsuariosUnidad,
    meta: { adminOnly: true },
  },
            {
                path: 'home',
                name: 'HomePag',
                component: HomePag,
            },
            {
                path: '',
                name: 'DashboardDefault',
                component: HomePag
            },
            {
                path:'generacion-proyecto',
                name:'GeneracionProyecto',
                component:GeneracionProyecto
            },
            {
                path:'nuevo-proyecto',
                name:'NuevoProyecto',
                component:NuevoProyecto
            },
            {
                path:'chatgpt',
                name:'ChatGPT',
                component:ChatGPT
            },
            {
                path:'registro',
                name:'RegistroUsuario',
                component:RegistroUsuario,
                meta: { adminOnly: true },
            },
            {
                path:'role-admin',
                name:'AdminRol',
                component:AdminRol,
                meta: { adminOnly: true },
            },
            {
                path:'equipos',
                name:'EquiposProyecto',
                component:EquiposProyecto
            },
            {
                path:'ProfileView',
                name:'ProfileView',
                component:ProfileView
            },
            {
                path: "/chat/:clave",
                name: "Chat",
                component: ChatVIew,
                props: true
            }




        ]

    },
    {
        path: '/register',
        name: 'registerPage',
        component: Register
    },
    {
        path: '/login/reset/confirm/:uidb64/:token/',
        name: 'PassConfirm',
        component: PassConfirmation,

    },

    {
        path: '/',
        redirect: '/index' // si querés redirigir raíz a dashboard
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: NotFound
    },

]

const router = new createRouter
    ({
        history: createWebHistory(),
        routes

    })

// Guard por rol: las rutas con meta.adminOnly solo las puede entrar "Admin QA".
// Owner u otros roles son redirigidos al inicio del dashboard.
router.beforeEach(async (to, _from, next) => {
    if (to.meta && to.meta.adminOnly) {
        const auth = useAuthStore();
        try {
            // Rol fresco desde el backend (fuente de verdad, no localStorage).
            await auth.ensureLoaded();
        } catch (e) {
            // Si no se pudo cargar (ej. 401), el interceptor ya redirige a login.
            // No forzamos salida aqui para no "sacar" al usuario por error.
            return next({ name: "HomePag" });
        }
        if (!auth.canAdminAccess) {
            // Autenticado pero sin permiso: avisamos y NO navegamos a esa vista.
            window.dispatchEvent(new CustomEvent("forbidden", {
                detail: { mensaje: "No tienes permiso para acceder a esta sección." },
            }));
            // Si venia navegando, se queda donde estaba; si entro por URL directa,
            // lo dejamos en el inicio del dashboard (no en login).
            if (_from && _from.name) return next(false);
            return next({ name: "HomePag" });
        }
    }
    next();
});

export default router